<cosmos-section
  [loading]="(_loading$ | async) === true"
  sectionTitle="Clusters"
  class="cosmos-user-clusters__section"
>
  <cosmos-table
    [columns]="_columns"
    [dataSource]="_dataSource"
    [isFilterable]="false"
    [isPaginable]="true"
    (clickedRow)="openClusterDetails($event)"
    paginatorType="compact"
  ></cosmos-table>
</cosmos-section>

<ng-template
  #checkboxTemplate
  let-data="row">
  <img
    *ngIf="data.id | featuredCluster | async"
    src="assets/icons/tick.svg"
    loading="lazy"
  />
</ng-template>

<ng-template
  #imageCell
  let-data="row">
  <div class="cosmos-user-clusters__image-container">
    <cosmos-image [src]="data.coverImageUrl"></cosmos-image>
  </div>
</ng-template>
